/** Shown when this tab no longer knows where the visitor came from, so it cannot send them back. */
export const BACK_TO_CHECKOUT_TAB = 'You can go back to your checkout tab.';

export const PRIMARY_BUTTON =
  'w-full rounded-2xl bg-[#5CB891] px-2 py-4 font-semibold text-white transition-all hover:bg-[#4aa07c] disabled:cursor-not-allowed disabled:bg-gray-300';
export const SECONDARY_BUTTON =
  'w-full rounded-2xl border-2 border-gray-200 px-2 py-4 font-semibold text-gray-900 transition-all hover:border-gray-300 disabled:cursor-not-allowed disabled:opacity-60';
